const highCostClaimantsMessages = {
  HIGH_COST_CLAIMANTS_PAGE: {
    TITLE: 'High-Cost Claimants',
    SUB_TITLE:
      'The top 10% of individuals contribute major portion of the cost of care, demonstrating the significance of personalized care plans and cost containment strategies for this high-cost group.',
    CARDS: {
      MEMBERS: 'Cohort Members',
      TOTAL_COST: 'Cohort Cost',
      PMPM: 'Cohort PMPM',
      PEPM: 'Cohort PEPM',
    },
    RX_CLAIMANTS_MEMBER_SUMMARY: 'Rx Claimants Member Summary',
    MEDICAL_CLAIMANTS_MEMBER_SUMMARY: 'Medical Claimants Member Summary',
    RX_CLAIMANTS_REPORT_MEMBER_SUMMARY:
      'High-Cost Claimants - Rx Claimants > $5K',
    MEDICAL_CLAIMANTS_REPORT_MEMBER_SUMMARY:
      'High-Cost Claimants - Medical Claimants > $10K',
    TOP_10_CLAIMANTS: 'Top High Cost Claimants',
    BREADCRUMB: {
      TEXT: 'text',
      SUMMARY: 'High Cost Claimants',
    },
  },
};

export default highCostClaimantsMessages;
